import React from "react";
import "../css/LoadingScreen.css";

const LoadingScreen = (props) => {
    return (
      <div className="loader-container">
        <img
          src="/Images/BRS-logo.png"
          className="brs-loading-logo"
          alt="brighton roofing specialists logo"
        />
        <div className="bouncing-loader">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    );
  };
  
  export default LoadingScreen;
  